import { render, staticRenderFns } from "./LeadsFilter.vue?vue&type=template&id=763d5afb&scoped=true&"
import script from "./LeadsFilter.vue?vue&type=script&lang=js&"
export * from "./LeadsFilter.vue?vue&type=script&lang=js&"
import style0 from "./LeadsFilter.vue?vue&type=style&index=0&id=763d5afb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763d5afb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VTooltip})
